import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context26; _forEachInstanceProperty(_context26 = ownKeys(Object(source), true)).call(_context26, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context27; _forEachInstanceProperty(_context27 = ownKeys(Object(source))).call(_context27, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/jsx-no-bind */
import React from 'react';
import types from 'prop-types';
import momentTypes from 'react-moment-proptypes';
import { nonNegativeInteger } from 'airbnb-prop-types';
import moment from 'moment';
import isTouchDevice from 'is-touch-device';
import { DayPickerKeyboardShortcutsPhrases, DayPickerNavigationPhrases } from '../defaultPhrases';
import getPhraseTypes from '../utils/getPhrasePropTypes';
import isSameDay from '../utils/isSameDay';
import isAfterDay from '../utils/isAfterDay';
import getVisibleDays from '../utils/getVisibleDays';
import isDayVisible from '../utils/isDayVisible';
import toISODateString from '../utils/toISODateString';
import toISOMonthString from '../utils/toISOMonthString';
import ScrollableOrientationShape from '../shapes/ScrollableOrientationShape';
import DayOfWeekShape from '../shapes/DayOfWeekShape';
import { HORIZONTAL_ORIENTATION, VERTICAL_SCROLLABLE, DAY_SIZE } from '../constants';
import DayPicker from './day-picker';
var values = _Object$values;
var propTypes = {
  date: momentTypes.momentObj,
  onDateChange: types.func,
  focused: types.bool,
  onFocusChange: types.func,
  onClose: types.func,
  keepOpenOnDateSelect: types.bool,
  minimumNights: types.number,
  isOutsideRange: types.func,
  isDayBlocked: types.func,
  isDayHighlighted: types.func,
  // DayPicker props
  renderMonth: types.func,
  enableOutsideDays: types.bool,
  numberOfMonths: types.number,
  orientation: ScrollableOrientationShape,
  withPortal: types.bool,
  initialVisibleMonth: types.func,
  firstDayOfWeek: DayOfWeekShape,
  hideKeyboardShortcutsPanel: types.bool,
  keyboardShortcutsCloseButton: types.node,
  daySize: nonNegativeInteger,
  navPrev: types.node,
  navNext: types.node,
  onPrevMonthClick: types.func,
  onNextMonthClick: types.func,
  onOutsideClick: types.func,
  renderDay: types.func,
  renderCalendarInfo: types.func,
  // accessibility
  onBlur: types.func,
  isFocused: types.bool,
  showKeyboardShortcuts: types.bool,
  // i18n
  monthFormat: types.string,
  dateIsUnavailableLabel: types.string,
  keyboardShortcutLabels: types.shape(getPhraseTypes(DayPickerKeyboardShortcutsPhrases)),
  navigationLabels: types.shape(getPhraseTypes(DayPickerNavigationPhrases)),
  isRTL: types.bool
};
var defaultProps = {
  onDateChange: function onDateChange() {},
  focused: false,
  onFocusChange: function onFocusChange() {},
  onClose: function onClose() {},
  keepOpenOnDateSelect: false,
  minimumNights: 1,
  isOutsideRange: function isOutsideRange() {},
  isDayBlocked: function isDayBlocked() {},
  isDayHighlighted: function isDayHighlighted() {},
  // DayPicker props
  enableOutsideDays: false,
  numberOfMonths: 1,
  orientation: HORIZONTAL_ORIENTATION,
  withPortal: false,
  hideKeyboardShortcutsPanel: false,
  daySize: DAY_SIZE,
  onPrevMonthClick: function onPrevMonthClick() {},
  onNextMonthClick: function onNextMonthClick() {},
  onOutsideClick: function onOutsideClick() {},
  // accessibility
  onBlur: function onBlur() {},
  isFocused: false,
  showKeyboardShortcuts: false,
  // i18n
  monthFormat: 'MMMM YYYY',
  isRTL: false
};

var DayPickerSingleDateController = /*#__PURE__*/function (_React$Component) {
  _inherits(DayPickerSingleDateController, _React$Component);

  var _super = _createSuper(DayPickerSingleDateController);

  function DayPickerSingleDateController(props) {
    var _context, _context2, _context3, _context4, _context5, _context6;

    var _this;

    _classCallCheck(this, DayPickerSingleDateController);

    _this = _super.call(this, props);
    _this.isTouchDevice = false;
    _this.today = moment();
    _this.modifiers = {
      today: function today(day) {
        return _this.isToday(day);
      },
      blocked: function blocked(day) {
        return _this.isBlocked(day);
      },
      blockedCalendar: function blockedCalendar(day) {
        return props.isDayBlocked(day);
      },
      blockedOutOfRange: function blockedOutOfRange(day) {
        return props.isOutsideRange(day);
      },
      highlightedCalendar: function highlightedCalendar(day) {
        return props.isDayHighlighted(day);
      },
      valid: function valid(day) {
        return !_this.isBlocked(day);
      },
      hovered: function hovered(day) {
        return _this.isHovered(day);
      },
      selected: function selected(day) {
        return _this.isSelected(day);
      }
    };

    var _this$getStateForNewM = _this.getStateForNewMonth(props),
        currentMonth = _this$getStateForNewM.currentMonth,
        visibleDays = _this$getStateForNewM.visibleDays;

    _this.state = {
      hoverDate: undefined,
      currentMonth: currentMonth,
      visibleDays: visibleDays
    };
    _this.onMouseEnter = _bindInstanceProperty(_context = _this.onMouseEnter).call(_context, _assertThisInitialized(_this));
    _this.onMouseLeave = _bindInstanceProperty(_context2 = _this.onMouseLeave).call(_context2, _assertThisInitialized(_this));
    _this.onClick = _bindInstanceProperty(_context3 = _this.onClick).call(_context3, _assertThisInitialized(_this));
    _this.onPrevMonthClick = _bindInstanceProperty(_context4 = _this.onPrevMonthClick).call(_context4, _assertThisInitialized(_this));
    _this.onNextMonthClick = _bindInstanceProperty(_context5 = _this.onNextMonthClick).call(_context5, _assertThisInitialized(_this));
    _this.getFirstFocusableDay = _bindInstanceProperty(_context6 = _this.getFirstFocusableDay).call(_context6, _assertThisInitialized(_this));
    return _this;
  }

  _createClass(DayPickerSingleDateController, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isTouchDevice = isTouchDevice();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var date = nextProps.date,
          focused = nextProps.focused,
          isOutsideRange = nextProps.isOutsideRange,
          isDayBlocked = nextProps.isDayBlocked,
          isDayHighlighted = nextProps.isDayHighlighted,
          initialVisibleMonth = nextProps.initialVisibleMonth,
          numberOfMonths = nextProps.numberOfMonths,
          enableOutsideDays = nextProps.enableOutsideDays;
      var visibleDays = this.state.visibleDays;

      if (isOutsideRange !== this.props.isOutsideRange) {
        this.modifiers.blockedOutOfRange = function (day) {
          return isOutsideRange(day);
        };
      }

      if (isDayBlocked !== this.props.isDayBlocked) {
        this.modifiers.blockedCalendar = function (day) {
          return isDayBlocked(day);
        };
      }

      if (isDayHighlighted !== this.props.isDayHighlighted) {
        this.modifiers.highlightedCalendar = function (day) {
          return isDayHighlighted(day);
        };
      }

      if (initialVisibleMonth !== this.props.initialVisibleMonth || numberOfMonths !== this.props.numberOfMonths || enableOutsideDays !== this.props.enableOutsideDays) {
        var newMonthState = this.getStateForNewMonth(nextProps);
        var currentMonth = newMonthState.currentMonth;
        visibleDays = newMonthState.visibleDays;
        this.setState({
          currentMonth: currentMonth,
          visibleDays: visibleDays
        });
      }

      var didDateChange = date !== this.props.date;
      var didFocusChange = focused !== this.props.focused;
      var modifiers = {};

      if (didDateChange) {
        modifiers = this.deleteModifier(modifiers, this.props.date, 'selected');
        modifiers = this.addModifier(modifiers, date, 'selected');
      }

      if (didFocusChange) {
        var _context7;

        _forEachInstanceProperty(_context7 = values(visibleDays)).call(_context7, function (days) {
          var _context8;

          _forEachInstanceProperty(_context8 = _Object$keys(days)).call(_context8, function (day) {
            var momentObj = moment(day);

            if (_this2.isBlocked(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
            }

            if (isOutsideRange(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, _this2.modifiers.blockedOutOfRange);
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, _this2.modifiers.blockedOutOfRange);
            }

            if (isDayBlocked(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, _this2.modifiers.blockedCalendar);
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, _this2.modifiers.blockedCalendar);
            }

            if (isDayHighlighted(momentObj)) {
              modifiers = _this2.addModifier(modifiers, momentObj, _this2.modifiers.highlightedCalendar);
            } else {
              modifiers = _this2.deleteModifier(modifiers, momentObj, _this2.modifiers.highlightedCalendar);
            }
          });
        });
      }

      var today = moment();

      if (!isSameDay(this.today, today)) {
        modifiers = this.deleteModifier(modifiers, this.today, 'today');
        modifiers = this.addModifier(modifiers, today, 'today');
        this.today = today;
      }

      if (_Object$keys(modifiers).length > 0) {
        this.setState({
          visibleDays: _objectSpread(_objectSpread({}, visibleDays), modifiers)
        });
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      this.today = moment();
    }
  }, {
    key: "onClick",
    value: function onClick(day, e) {
      if (e) e.preventDefault();
      if (this.isBlocked(day)) return;
      var _this$props = this.props,
          onDateChange = _this$props.onDateChange,
          keepOpenOnDateSelect = _this$props.keepOpenOnDateSelect,
          onFocusChange = _this$props.onFocusChange,
          onClose = _this$props.onClose;
      onDateChange(day);

      if (!keepOpenOnDateSelect) {
        onFocusChange(false);
        onClose({
          date: day
        });
      }
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(day) {
      if (this.isTouchDevice) return;
      var _this$state = this.state,
          hoverDate = _this$state.hoverDate,
          visibleDays = _this$state.visibleDays;
      var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
      modifiers = this.addModifier(modifiers, day, 'hovered');
      this.setState({
        hoverDate: day,
        visibleDays: _objectSpread(_objectSpread({}, visibleDays), modifiers)
      });
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      var _this$state2 = this.state,
          hoverDate = _this$state2.hoverDate,
          visibleDays = _this$state2.visibleDays;
      if (this.isTouchDevice || !hoverDate) return;
      var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
      this.setState({
        hoverDate: undefined,
        visibleDays: _objectSpread(_objectSpread({}, visibleDays), modifiers)
      });
    }
  }, {
    key: "onPrevMonthClick",
    value: function onPrevMonthClick() {
      var _context9, _context10, _context11;

      var _this$props2 = this.props,
          onPrevMonthClick = _this$props2.onPrevMonthClick,
          numberOfMonths = _this$props2.numberOfMonths,
          enableOutsideDays = _this$props2.enableOutsideDays;
      var _this$state3 = this.state,
          currentMonth = _this$state3.currentMonth,
          visibleDays = _this$state3.visibleDays;
      var newVisibleDays = {};

      _forEachInstanceProperty(_context9 = _sliceInstanceProperty(_context10 = _sortInstanceProperty(_context11 = _Object$keys(visibleDays)).call(_context11)).call(_context10, 0, numberOfMonths + 1)).call(_context9, function (month) {
        newVisibleDays[month] = visibleDays[month];
      });

      var prevMonth = currentMonth.clone().subtract(1, 'month');
      var prevMonthVisibleDays = getVisibleDays(prevMonth, 1, enableOutsideDays);
      this.setState({
        currentMonth: prevMonth,
        visibleDays: _objectSpread(_objectSpread({}, newVisibleDays), this.getModifiers(prevMonthVisibleDays))
      });
      onPrevMonthClick();
    }
  }, {
    key: "onNextMonthClick",
    value: function onNextMonthClick() {
      var _context12, _context13, _context14;

      var _this$props3 = this.props,
          onNextMonthClick = _this$props3.onNextMonthClick,
          numberOfMonths = _this$props3.numberOfMonths,
          enableOutsideDays = _this$props3.enableOutsideDays;
      var _this$state4 = this.state,
          currentMonth = _this$state4.currentMonth,
          visibleDays = _this$state4.visibleDays;
      var newVisibleDays = {};

      _forEachInstanceProperty(_context12 = _sliceInstanceProperty(_context13 = _sortInstanceProperty(_context14 = _Object$keys(visibleDays)).call(_context14)).call(_context13, 1)).call(_context12, function (month) {
        newVisibleDays[month] = visibleDays[month];
      });

      var nextMonth = currentMonth.clone().add(numberOfMonths, 'month');
      var nextMonthVisibleDays = getVisibleDays(nextMonth, 1, enableOutsideDays);
      this.setState({
        currentMonth: currentMonth.clone().add(1, 'month'),
        visibleDays: _objectSpread(_objectSpread({}, newVisibleDays), this.getModifiers(nextMonthVisibleDays))
      });
      onNextMonthClick();
    }
  }, {
    key: "getFirstFocusableDay",
    value: function getFirstFocusableDay(newMonth) {
      var _this3 = this;

      var _this$props4 = this.props,
          date = _this$props4.date,
          numberOfMonths = _this$props4.numberOfMonths;
      var focusedDate = newMonth.clone().startOf('month');

      if (date) {
        focusedDate = date.clone();
      }

      if (this.isBlocked(focusedDate)) {
        var days = [];
        var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
        var currentDay = focusedDate.clone();

        while (!isAfterDay(currentDay, lastVisibleDay)) {
          currentDay = currentDay.clone().add(1, 'day');
          days.push(currentDay);
        }

        var viableDays = _filterInstanceProperty(days).call(days, function (day) {
          return !_this3.isBlocked(day) && isAfterDay(day, focusedDate);
        });

        if (viableDays.length > 0) focusedDate = viableDays[0];
      }

      return focusedDate;
    }
  }, {
    key: "getModifiers",
    value: function getModifiers(visibleDays) {
      var _context15,
          _this4 = this;

      var modifiers = {};

      _forEachInstanceProperty(_context15 = _Object$keys(visibleDays)).call(_context15, function (month) {
        var _context16;

        modifiers[month] = {};

        _forEachInstanceProperty(_context16 = visibleDays[month]).call(_context16, function (day) {
          modifiers[month][toISODateString(day)] = _this4.getModifiersForDay(day);
        });
      });

      return modifiers;
    }
  }, {
    key: "getModifiersForDay",
    value: function getModifiersForDay(day) {
      var _context17,
          _this5 = this;

      return _filterInstanceProperty(_context17 = _Object$keys(this.modifiers)).call(_context17, function (modifier) {
        return _this5.modifiers[modifier](day);
      });
    }
  }, {
    key: "getStateForNewMonth",
    value: function getStateForNewMonth(nextProps) {
      var _this6 = this;

      var initialVisibleMonth = nextProps.initialVisibleMonth,
          date = nextProps.date,
          numberOfMonths = nextProps.numberOfMonths,
          enableOutsideDays = nextProps.enableOutsideDays;
      var initialVisibleMonthThunk = initialVisibleMonth || (date ? function () {
        return date;
      } : function () {
        return _this6.today;
      });
      var currentMonth = initialVisibleMonthThunk();
      var visibleDays = this.getModifiers(getVisibleDays(currentMonth, numberOfMonths, enableOutsideDays));
      return {
        currentMonth: currentMonth,
        visibleDays: visibleDays
      };
    }
  }, {
    key: "addModifier",
    value: function addModifier(updatedDays, day, modifier) {
      var _this$props5 = this.props,
          numberOfVisibleMonths = _this$props5.numberOfMonths,
          enableOutsideDays = _this$props5.enableOutsideDays,
          orientation = _this$props5.orientation;
      var _this$state5 = this.state,
          firstVisibleMonth = _this$state5.currentMonth,
          visibleDays = _this$state5.visibleDays;
      var currentMonth = firstVisibleMonth;
      var numberOfMonths = numberOfVisibleMonths;

      if (orientation !== VERTICAL_SCROLLABLE) {
        currentMonth = currentMonth.clone().subtract(1, 'month');
        numberOfMonths += 2;
      }

      if (!day || !isDayVisible(day, currentMonth, numberOfMonths, enableOutsideDays)) {
        return updatedDays;
      }

      var iso = toISODateString(day);

      var updatedDaysAfterAddition = _objectSpread({}, updatedDays);

      if (enableOutsideDays) {
        var _context18;

        var monthsToUpdate = _filterInstanceProperty(_context18 = _Object$keys(visibleDays)).call(_context18, function (monthKey) {
          var _context19;

          return _indexOfInstanceProperty(_context19 = _Object$keys(visibleDays[monthKey])).call(_context19, iso) > -1;
        });

        updatedDaysAfterAddition = _reduceInstanceProperty(monthsToUpdate).call(monthsToUpdate, function (days, monthIso) {
          var _context20;

          var month = updatedDays[monthIso] || visibleDays[monthIso];
          return _objectSpread(_objectSpread({}, days), {}, _defineProperty({}, monthIso, _objectSpread(_objectSpread({}, month), {}, _defineProperty({}, iso, _concatInstanceProperty(_context20 = []).call(_context20, _toConsumableArray(month[iso]), [modifier])))));
        }, updatedDaysAfterAddition);
      } else {
        var _context21;

        var monthIso = toISOMonthString(day);
        var month = updatedDays[monthIso] || visibleDays[monthIso];
        updatedDaysAfterAddition = _objectSpread(_objectSpread({}, updatedDaysAfterAddition), {}, _defineProperty({}, monthIso, _objectSpread(_objectSpread({}, month), {}, _defineProperty({}, iso, _concatInstanceProperty(_context21 = []).call(_context21, _toConsumableArray(month[iso]), [modifier])))));
      }

      return updatedDaysAfterAddition;
    }
  }, {
    key: "deleteModifier",
    value: function deleteModifier(updatedDays, day, modifier) {
      var _this$props6 = this.props,
          numberOfVisibleMonths = _this$props6.numberOfMonths,
          enableOutsideDays = _this$props6.enableOutsideDays,
          orientation = _this$props6.orientation;
      var _this$state6 = this.state,
          firstVisibleMonth = _this$state6.currentMonth,
          visibleDays = _this$state6.visibleDays;
      var currentMonth = firstVisibleMonth;
      var numberOfMonths = numberOfVisibleMonths;

      if (orientation !== VERTICAL_SCROLLABLE) {
        currentMonth = currentMonth.clone().subtract(1, 'month');
        numberOfMonths += 2;
      }

      if (!day || !isDayVisible(day, currentMonth, numberOfMonths, enableOutsideDays)) {
        return updatedDays;
      }

      var iso = toISODateString(day);

      var updatedDaysAfterDeletion = _objectSpread({}, updatedDays);

      if (enableOutsideDays) {
        var _context22;

        var monthsToUpdate = _filterInstanceProperty(_context22 = _Object$keys(visibleDays)).call(_context22, function (monthKey) {
          var _context23;

          return _indexOfInstanceProperty(_context23 = _Object$keys(visibleDays[monthKey])).call(_context23, iso) > -1;
        });

        updatedDaysAfterDeletion = _reduceInstanceProperty(monthsToUpdate).call(monthsToUpdate, function (days, monthIso) {
          var _context24;

          var month = updatedDays[monthIso] || visibleDays[monthIso];
          return _objectSpread(_objectSpread({}, days), {}, _defineProperty({}, monthIso, _objectSpread(_objectSpread({}, month), {}, _defineProperty({}, iso, _filterInstanceProperty(_context24 = month[iso]).call(_context24, function (m) {
            return m !== modifier;
          })))));
        }, updatedDaysAfterDeletion);
      } else {
        var _context25;

        var monthIso = toISOMonthString(day);
        var month = updatedDays[monthIso] || visibleDays[monthIso];
        updatedDaysAfterDeletion = _objectSpread(_objectSpread({}, updatedDaysAfterDeletion), {}, _defineProperty({}, monthIso, _objectSpread(_objectSpread({}, month), {}, _defineProperty({}, iso, _filterInstanceProperty(_context25 = month[iso]).call(_context25, function (m) {
          return m !== modifier;
        })))));
      }

      return updatedDaysAfterDeletion;
    }
  }, {
    key: "isBlocked",
    value: function isBlocked(day) {
      var _this$props7 = this.props,
          isDayBlocked = _this$props7.isDayBlocked,
          isOutsideRange = _this$props7.isOutsideRange;
      return isDayBlocked(day) || isOutsideRange(day);
    }
  }, {
    key: "isHovered",
    value: function isHovered(day) {
      var _ref = this.state || {},
          hoverDate = _ref.hoverDate;

      return isSameDay(day, hoverDate);
    }
  }, {
    key: "isSelected",
    value: function isSelected(day) {
      return isSameDay(day, this.props.date);
    }
  }, {
    key: "isToday",
    value: function isToday(day) {
      return isSameDay(day, this.today);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          onOutsideClick = _this$props8.onOutsideClick,
          numberOfMonths = _this$props8.numberOfMonths,
          orientation = _this$props8.orientation,
          monthFormat = _this$props8.monthFormat,
          renderMonth = _this$props8.renderMonth,
          navPrev = _this$props8.navPrev,
          navNext = _this$props8.navNext,
          withPortal = _this$props8.withPortal,
          focused = _this$props8.focused,
          enableOutsideDays = _this$props8.enableOutsideDays,
          hideKeyboardShortcutsPanel = _this$props8.hideKeyboardShortcutsPanel,
          keyboardShortcutsCloseButton = _this$props8.keyboardShortcutsCloseButton,
          daySize = _this$props8.daySize,
          firstDayOfWeek = _this$props8.firstDayOfWeek,
          renderDay = _this$props8.renderDay,
          renderCalendarInfo = _this$props8.renderCalendarInfo,
          isFocused = _this$props8.isFocused,
          dateIsUnavailableLabel = _this$props8.dateIsUnavailableLabel,
          keyboardShortcutLabels = _this$props8.keyboardShortcutLabels,
          navigationLabels = _this$props8.navigationLabels,
          isRTL = _this$props8.isRTL,
          renderWeekDay = _this$props8.renderWeekDay,
          weekDayFormat = _this$props8.weekDayFormat,
          padding = _this$props8.padding,
          monthPadding = _this$props8.monthPadding,
          paddingBottom = _this$props8.paddingBottom;
      var _this$state7 = this.state,
          currentMonth = _this$state7.currentMonth,
          visibleDays = _this$state7.visibleDays;
      return /*#__PURE__*/React.createElement(DayPicker, {
        orientation: orientation,
        enableOutsideDays: enableOutsideDays,
        modifiers: visibleDays,
        numberOfMonths: numberOfMonths,
        onClick: this.onClick,
        onOutsideClick: onOutsideClick,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onPrevMonthClick: this.onPrevMonthClick,
        onNextMonthClick: this.onNextMonthClick,
        monthFormat: monthFormat,
        withPortal: withPortal,
        hidden: !focused,
        hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
        keyboardShortcutsCloseButton: keyboardShortcutsCloseButton,
        initialVisibleMonth: function initialVisibleMonth() {
          return currentMonth;
        },
        firstDayOfWeek: firstDayOfWeek,
        navPrev: navPrev,
        navNext: navNext,
        renderMonth: renderMonth,
        renderDay: renderDay,
        renderCalendarInfo: renderCalendarInfo,
        isFocused: isFocused,
        getFirstFocusableDay: this.getFirstFocusableDay,
        onBlur: this.onPickerBlur,
        dateIsUnavailableLabel: dateIsUnavailableLabel,
        keyboardShortcutLabels: keyboardShortcutLabels,
        navigationLabels: navigationLabels,
        daySize: daySize,
        isRTL: isRTL,
        renderWeekDay: renderWeekDay,
        weekDayFormat: weekDayFormat,
        padding: padding,
        monthPadding: monthPadding,
        paddingBottom: paddingBottom
      });
    }
  }]);

  return DayPickerSingleDateController;
}(React.Component);

export { DayPickerSingleDateController as default };
DayPickerSingleDateController.propTypes = propTypes;
DayPickerSingleDateController.defaultProps = defaultProps;